import React from "react";
import emailjs from "emailjs-com";
import "./contact.css";

const Contact = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          alert("Mesajınız başarıyla gönderildi 🌿");
          e.target.reset();
        },
        (error) => {
          alert("Bir hata oluştu, lütfen tekrar deneyin.");
          console.error("EmailJS Hatası:", error);
        }
      );
  };

  return (
    <>
      <div className="rotating-container">
        {/*Contact*/}
        <div className="contact-map">
          <div className="contact">
            <h1
              className="text-center fw-bold"
              style={{
                fontSize: "clamp(35px, 5vw, 60px)",
                marginBottom: "20px",
              }}
            >
              İletişim
            </h1>
            <div className="contact-description text-center mb-4 fs-6">
              <p className="mb-2">
                Randevu oluşturmak ya da çalışmalarım hakkında bilgi almak
                isterseniz iletişim formunu kullanabilirsiniz.
              </p>
              <p className="text-muted italic">
                Sizlere en kısa sürede geri dönüş sağlanacaktır.
              </p>
            </div>

            <form onSubmit={sendEmail}>
              <div className="name-row">
                <div>
                  <label>Adınız</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    required
                  />
                </div>

                <div>
                  <label>Soyadınız</label>
                  <input
                    type="text"
                    name="surname"
                    className="form-control"
                    required
                  />
                </div>
              </div>

              <div className="mb-2">
                <label htmlFor="InputEmail" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  id="InputEmail"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Mesaj
                </label>
                <textarea
                  className="form-control"
                  name="message"
                  id="message"
                  rows="4"
                  required
                />
              </div>

              <div className="form-check mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  required
                  id="kvkk"
                />
                <label className="form-check-label text-muted" htmlFor="kvkk">
                  Kişisel verilerimin iletişim amacıyla işlenmesini kabul
                  ediyorum.
                </label>
              </div>

              <div className="d-grid mt-4">
                <button type="submit" className="btn btn-dark btn-lg fs-6">
                  Gönder
                </button>
              </div>
            </form>
          </div>

          {/*<div className="col-md-6 d-flex justify-content-center align-items-center">
        <iframe title="Psikoloji Antalya Google Maps Konumu"src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6385.388998704183!2d30.761397!3d36.849792!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c39be3b10b0abd%3A0x71374c2d06cee53!2sPsikoloji%20Antalya%20Lara!5e0!3m2!1str!2str!4v1755431733045!5m2!1str!2str" width="400" height="400" style={{ borderRadius: "200px" }} loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

    </div> */}
        </div>
      </div>
    </>
  );
};

export default Contact;
